<template>
  <div v-if="mostrar" class="modal-overlay">
    <div class="modal-container">
      <!-- Cabeçalho -->
      <div class="modal-header">
        <h6>Ampliar prazo da Avaliação</h6>
        <i class="bi bi-x-circle close-icon" @click="$emit('fechar')"></i>
      </div>

      <!-- Conteúdo -->
      <div class="modal-content">
        <div class="mb-3">
          <h5 class="section-title">Dados do Período</h5>
          <div class="row">
            <div class="col-12">
              <div class="form-control-plaintext">{{ periodo?.nome }}</div>
            </div>
            <div class="col-3">
              <label>Início</label>
              {{ inicioBR }}
            </div>
            <div class="col-3">
              <label>Fim atual</label>
              {{ fimAtualBR }}
            </div>
          </div>
        </div>

        <div>
          <h5 class="section-title">Novo prazo</h5>
          <div class="row">
            <div class="col-4">
              <label>Nova data de Fim <span class="required">*</span></label>
              <input
                type="date"
                class="form-control"
                v-model="novoFim"
                :min="minDate"
              />
                <small v-if="erroMsg" class="text-danger">{{ erroMsg }}</small>
                <small v-else-if="erroServidor" class="text-danger">{{ erroServidor }}</small>
            </div>
          </div>
        </div>
      </div>

      <!-- Rodapé -->
      <div class="modal-footer">
        <button class="btn btn-secondary" @click="$emit('fechar')" :disabled="isSaving">Cancelar</button>
        <button class="btn btn-primary" @click="salvar" :disabled="!formValido || isSaving">
          <span v-if="isSaving" class="spinner-border spinner-border-sm mr-2"></span>
          Salvar
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue'
import axios from '@/services/axios'
// import globalUtils from '@/utils/globalUtils.js';

const props = defineProps({
  mostrar: { type: Boolean, default: false },
  periodo: { type: Object, default: null }
})
const emit = defineEmits(['fechar', 'salvou'])

const novoFim = ref('')
const isSaving = ref(false)

const inicioBR   = computed(() => formatarBR(props.periodo?.data_inicio || props.periodo?.inicio || props.periodo?.inicio_vigencia))
const fimAtualBR = computed(() => formatarBR(props.periodo?.data_fim    || props.periodo?.fim    || props.periodo?.termino_vigencia))

// Erros
const erroServidor = ref('')

// Ao abrir o modal, carregar o Fim atual e limpar erro de servidor
watch(() => props.mostrar, (v) => {
  if (!v) return
  erroServidor.value = ''
  novoFim.value = toISO(props.periodo?.data_fim) || ''
})

// Datas de referência (derivadas)
const inicioISO = computed(() => toISO(props.periodo?.data_inicio))
const fimISOAtual = computed(() => toISO(props.periodo?.data_fim))

// Para "ampliar", mínimo sugerido é o Fim atual; se não houver, usa Início; se não houver, hoje.
const minDate = computed(() => fimISOAtual.value || inicioISO.value || todayISO())

// Mensagem de validação (SOMENTE leitura)
const erroMsg = computed(() => {
  if (!novoFim.value) return 'Informe a nova data de Fim.'
  if (inicioISO.value && novoFim.value < inicioISO.value) return 'Novo Fim não pode ser antes do Início.'
  if (fimISOAtual.value && novoFim.value < fimISOAtual.value) return 'Para ampliar, escolha data igual ou posterior ao Fim atual.'
  return ''
})

function formatarBR(s) {
  if (!s) return ''
  // já vem pronto (DD/MM/YYYY) da listagem
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(s)) return s
  // quando vier ISO (YYYY-MM-DD) do GET/:id, formata para BR
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(s)
  return m ? `${m[3]}/${m[2]}/${m[1]}` : s
}

// Formulário válido quando não há mensagem de erro
const formValido = computed(() => erroMsg.value === '')

async function salvar() {
  if (!formValido.value) return
  isSaving.value = true
  try {
    await axios.patch(`/cadastros/avaliacoes-periodos/${props.periodo.id}/fim`, {
      data_fim: novoFim.value
    })
    emit('salvou')
  } catch (e) {
    erroServidor.value = e?.response?.data?.error || 'Não foi possível salvar.'
  } finally {
    isSaving.value = false
  }
}

// utils de data
function toISO(s) {
  if (!s) return ''
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0,10)
  const m = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(s) // DD/MM/YYYY
  if (m) return `${m[3]}-${m[2]}-${m[1]}`
  return ''
}
function todayISO() { return new Date().toISOString().slice(0,10) }
</script>

<style scoped>
/* Reaproveita o estilo do modal do seu TrancarMatricula.vue */
.modal-footer {
  display: flex; gap: 8px; justify-content: flex-end;
  padding: 12px 16px; border-top: 1px solid #eee;
}

  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .modal-container {
    background: #fff;
    width: 100%;
    max-width: 30%;
    margin: 0 10px;
    border-radius: 4px;
    overflow: hidden;
  }
  .modal-header {
    background: #ccc;
    padding: 10px 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .close-icon {
    font-size: 1.5rem;
    cursor: pointer;
  }
  .modal-content {
    padding: 15px;
  }
  label {
    font-size: 0.8rem;
    font-weight: 500;
  }
  .section-title {
    font-size: 0.9rem;
    font-weight: bold;
    margin-bottom: 10px;
  }

</style>
